export default __webpack_public_path__ + "85772341ad10e9fd5d827e206956a321.svg";